import React from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import Home from './pages/Home';
import Chatbots from './pages/Chatbots';
import './index.css';
import '@questlabs/react-sdk/dist/style.css';


function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chatbots" element={<Chatbots />} />
      </Routes>
    </HashRouter>
  );
}

export default App;